import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '@/features/settings/SettingsLayout';

/** Layout à onglets verticaux de `/settings` ; chaque onglet est une route enfant. */
export const Route = createFileRoute('/_auth/settings')({
  component: SettingsLayout,
});
